import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum GetGiftReceiptCountErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
}

export const getGiftReceiptCount = {
  name: "getGiftReceiptCount" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({ count: z.number() }),
};
